import React from "react";
import logoLight from "../../assets/images/logo-light.png";
import logo from "../../logo.svg";

function LogoBlock() {
  return (
    <div className="text-center">
      <a href="/" className="logo-dark">
        <img
          src={logo}
          alt="logo dark"
          height="60"
          className="auth-logo logo-dark mx-auto"
        />
      </a>
    </div>
  );
}
export default LogoBlock;
